export const MAX_BUSINESS_MEDIA_ITEMS = 30;
export const MAX_BUSINESS_VIDEO_DURATION = 60;

export const getBusinessMediaType = (fileOrType) => {
  const typeValue =
    typeof fileOrType === "string" ? fileOrType : fileOrType?.type || "";

  if (typeValue.startsWith("image/") || typeValue === "image") {
    return "image";
  }

  if (typeValue.startsWith("video/") || typeValue === "video") {
    return "video";
  }

  return null;
};

export const getVideoDuration = (file) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const video = document.createElement("video");

    video.preload = "metadata";
    video.onloadedmetadata = () => {
      const duration = video.duration || 0;
      URL.revokeObjectURL(objectUrl);
      resolve(duration);
    };
    video.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to read video duration"));
    };
    video.src = objectUrl;
  });

export const normalizeBusinessMedia = (mediaItems = [], fallbackPhotos = []) => {
  const source =
    Array.isArray(mediaItems) && mediaItems.length > 0 ? mediaItems : fallbackPhotos;

  return source
    .map((item) => {
      if (typeof item === "string") {
        const url = item.trim();
        return url
          ? {
              type: "image",
              url,
              preview: url,
              size: 0,
            }
          : null;
      }

      if (!item || typeof item !== "object") return null;

      const type = getBusinessMediaType(item.type || item.mediaType || item.mimeType) || "image";
      const url =
        (typeof item.url === "string" && item.url.trim()) ||
        (typeof item.image === "string" && item.image.trim()) ||
        (typeof item.video === "string" && item.video.trim()) ||
        "";

      if (!url) return null;

      return {
        type,
        url,
        preview: url,
        size: Number(item.size) || Number(item.fileSize) || 0,
        duration: type === "video" ? Number(item.duration) || 0 : undefined,
        thumbnail:
          typeof item.thumbnail === "string" && item.thumbnail.trim()
            ? item.thumbnail.trim()
            : undefined,
      };
    })
    .filter(Boolean)
    .slice(0, MAX_BUSINESS_MEDIA_ITEMS);
};

export const toBusinessMediaPayload = (mediaItems = []) =>
  mediaItems
    .map((item) => {
      if (!item?.url || !item?.type) return null;

      const payloadItem = {
        type: item.type,
        url: item.url,
        size: Number(item.size) || 0,
      };

      if (item.type === "video") {
        payloadItem.duration = Number(item.duration) || 0;
      }

      return payloadItem;
    })
    .filter(Boolean)
    .slice(0, MAX_BUSINESS_MEDIA_ITEMS);
